(() => {
  if (window.__campoNobleRegionsInitialized) return;
  window.__campoNobleRegionsInitialized = true;

  const REGION_KEY = 'region';
  const TOWN_KEY = 'comuna';
  const REGION_PLACEHOLDER = 'Selecciona tu región';
  const TOWN_PLACEHOLDER = 'Selecciona tu comuna';
  let draftRegion = '';
  let draftTown = '';
  let committedRegion = '';
  let committedTown = '';

  const getConfig = () => window.CampoNobleRegionConfig || { enabled: false, regions: [] };

  const parseTowns = (value) => Array.from(new Set((value || '')
    .split(/\r?\n/)
    .map((town) => town.trim())
    .filter(Boolean)));

  const getRegions = () => {
    const regions = {};
    const configuredRegions = Array.isArray(getConfig().regions) ? getConfig().regions : [];
    configuredRegions.forEach((region) => {
      const code = (region.code || '').trim().toUpperCase();
      const towns = parseTowns(region.towns);
      if (code && region.enabled && towns.length) regions[code] = { ...region, code, towns };
    });
    return regions;
  };

  const getCookie = (key) => {
    const cookieName = `${encodeURIComponent(key)}=`;
    const cookie = document.cookie.split('; ').find((item) => item.startsWith(cookieName));
    return cookie ? decodeURIComponent(cookie.slice(cookieName.length)) : '';
  };

  const setCookie = (key, value) => {
    const maxAge = value ? 31536000 : 0;
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax; Secure`;
  };

  const getStored = (key) => {
    try {
      return localStorage.getItem(key) || getCookie(key);
    } catch (error) {
      return getCookie(key);
    }
  };

  const setStored = (key, value) => {
    try {
      if (value) localStorage.setItem(key, value);
      else localStorage.removeItem(key);
    } catch (error) {
      // Local storage may be unavailable in privacy mode.
    }
    setCookie(key, value);
  };

  const validSelection = (region, town) => {
    const regions = getRegions();
    return Boolean(region && town && regions[region] && regions[region].towns.includes(town));
  };

  const fillRegions = (select) => {
    const selected = select.value;
    select.innerHTML = `<option value="">${REGION_PLACEHOLDER}</option>`;
    Object.entries(getRegions()).forEach(([code, region]) => {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = region.name;
      select.appendChild(option);
    });
    select.value = getRegions()[selected] ? selected : '';
  };

  const fillTowns = (select, region, selectedTown = '') => {
    select.innerHTML = `<option value="">${TOWN_PLACEHOLDER}</option>`;
    const regionData = getRegions()[region];
    if (!regionData) return;
    regionData.towns.forEach((town) => {
      const option = document.createElement('option');
      option.value = town;
      option.textContent = town;
      select.appendChild(option);
    });
    select.value = regionData.towns.includes(selectedTown) ? selectedTown : '';
  };

  const setPopupVisible = (visible) => {
    document.querySelectorAll('.js-region-popup').forEach((popup) => {
      popup.hidden = !visible;
    });
    document.body.classList.toggle('region-popup-open', visible);
  };

  const applyRegionContent = (region) => {
    document.documentElement.dataset.campoNobleRegion = region || '';
    document.querySelectorAll('[data-region-content]').forEach((element) => {
      const regions = (element.dataset.regionContent || '').split(',').map((value) => value.trim());
      element.hidden = !region || (!regions.includes('ALL') && !regions.includes(region));
    });
    document.querySelectorAll('.cc-featured-collection, .cc-region-collection-list, .cc-region-media-grid').forEach((section) => {
      const items = Array.from(section.querySelectorAll('[data-region-managed-item]'));
      if (items.length) section.hidden = !items.some((item) => !item.hidden);
    });
  };

  const dispatchRegionPreview = (region, town, source) => {
    window.dispatchEvent(new CustomEvent('campo-noble:region-preview', {
      detail: { region, comuna: town, source }
    }));
  };

  const previewSelection = (region, town, source) => {
    applyRegionContent(region);
    dispatchRegionPreview(region, town, source);
  };

  const syncControls = (region, town) => {
    document.querySelectorAll('.js-region-selector').forEach((selector) => {
      const regionSelect = selector.querySelector('.js-region-select');
      const townSelect = selector.querySelector('.js-town-select');
      if (!regionSelect || !townSelect) return;
      fillRegions(regionSelect);
      regionSelect.value = getRegions()[region] ? region : '';
      fillTowns(townSelect, regionSelect.value, town);
    });

    document.querySelectorAll('.js-region-current-town').forEach((label) => {
      label.textContent = town || label.dataset.defaultLabel || TOWN_PLACEHOLDER;
    });
  };

  const resetDraftSelection = (source = 'reset') => {
    draftRegion = committedRegion;
    draftTown = committedTown;
    syncControls(committedRegion, committedTown);
    previewSelection(committedRegion, committedTown, source);
  };

  const commitSelection = (region, town, source) => {
    if (!validSelection(region, town)) return false;
    draftRegion = region;
    draftTown = town;
    committedRegion = region;
    committedTown = town;
    setStored(REGION_KEY, region);
    setStored(TOWN_KEY, town);
    syncControls(region, town);
    applyRegionContent(region);
    setPopupVisible(false);
    window.dispatchEvent(new CustomEvent('campo-noble:region-change', {
      detail: { region, comuna: town, source }
    }));
    return true;
  };

  const markInvalid = (regionSelect, townSelect) => {
    regionSelect.classList.toggle('is-invalid', !regionSelect.value);
    townSelect.classList.toggle('is-invalid', !townSelect.value);
  };

  const initSelector = (selector) => {
    if (selector.dataset.regionInitialized === 'true') return;
    const regionSelect = selector.querySelector('.js-region-select');
    const townSelect = selector.querySelector('.js-town-select');
    const save = selector.querySelector('.js-region-save');
    if (!regionSelect || !townSelect || !save) return;

    fillRegions(regionSelect);
    const storedRegion = getStored(REGION_KEY);
    const storedTown = getStored(TOWN_KEY);
    const initialRegion = getRegions()[draftRegion] ? draftRegion : storedRegion;
    const initialTown = draftRegion ? draftTown : storedTown;
    regionSelect.value = getRegions()[initialRegion] ? initialRegion : '';
    fillTowns(townSelect, regionSelect.value, initialTown);

    regionSelect.addEventListener('change', () => {
      draftRegion = regionSelect.value;
      draftTown = '';
      fillTowns(townSelect, regionSelect.value);
      regionSelect.classList.remove('is-invalid');
      townSelect.classList.remove('is-invalid');
      previewSelection(draftRegion, draftTown, selector.dataset.regionSource || 'selector');
    });
    townSelect.addEventListener('change', () => {
      draftRegion = regionSelect.value;
      draftTown = townSelect.value;
      townSelect.classList.remove('is-invalid');
      previewSelection(draftRegion, draftTown, selector.dataset.regionSource || 'selector');
    });
    save.addEventListener('click', (event) => {
      event.preventDefault();
      markInvalid(regionSelect, townSelect);
      if (!validSelection(regionSelect.value, townSelect.value)) return;
      const beforeChange = new CustomEvent('campo-noble:before-region-change', {
        cancelable: true,
        detail: {
          region: regionSelect.value,
          comuna: townSelect.value,
          source: selector.dataset.regionSource || 'selector'
        }
      });
      if (!window.dispatchEvent(beforeChange)) return;
      if (!commitSelection(regionSelect.value, townSelect.value, selector.dataset.regionSource || 'selector')) return;
      const panel = selector.closest('.js-header-region')?.querySelector('.js-header-region-panel');
      const toggle = selector.closest('.js-header-region')?.querySelector('.js-header-region-toggle');
      if (panel && toggle) {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    selector.dataset.regionInitialized = 'true';
  };

  const initHeaderToggle = (root) => {
    if (root.dataset.toggleInitialized === 'true') return;
    const toggle = root.querySelector('.js-header-region-toggle');
    const panel = root.querySelector('.js-header-region-panel');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', () => {
      if (panel.hidden) resetDraftSelection('header-open');
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
    });
    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) {
        if (!panel.hidden) resetDraftSelection('header-close');
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    root.dataset.toggleInitialized = 'true';
  };

  const updateMobileMenuPosition = (toggle) => {
    const header = toggle.closest('store-header');
    if (!header) return;
    const headerEnd = Math.max(0, header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--header-end', `${headerEnd.toFixed(1)}px`);
    document.documentElement.style.setProperty('--header-end-padded', `${(headerEnd + 20).toFixed(1)}px`);
  };

  const initRegionalMenuToggle = (toggle) => {
    if (toggle.dataset.regionMenuPositionInitialized === 'true') return;
    toggle.addEventListener('click', () => {
      if (typeof window.setHeaderHeight === 'function') window.setHeaderHeight();
      updateMobileMenuPosition(toggle);
      requestAnimationFrame(() => updateMobileMenuPosition(toggle));
    });
    toggle.dataset.regionMenuPositionInitialized = 'true';
  };

  const initialize = (scope = document) => {
    if (!getConfig().enabled) return;
    scope.querySelectorAll('.js-region-selector').forEach(initSelector);
    scope.querySelectorAll('.js-header-region').forEach(initHeaderToggle);
    scope.querySelectorAll('.header-region-menu .main-menu__toggle').forEach(initRegionalMenuToggle);

    let storedRegion = getStored(REGION_KEY);
    let storedTown = getStored(TOWN_KEY);
    if (validSelection(storedRegion, storedTown)) {
      committedRegion = storedRegion;
      committedTown = storedTown;
    } else if (!validSelection(committedRegion, committedTown)) {
      storedRegion = '';
      storedTown = '';
      committedRegion = '';
      committedTown = '';
      setStored(REGION_KEY, '');
      setStored(TOWN_KEY, '');
    }
    const region = getRegions()[draftRegion] ? draftRegion : storedRegion;
    const town = getRegions()[region]?.towns.includes(draftTown) ? draftTown : storedTown;
    syncControls(region, town);
    applyRegionContent(committedRegion);
    setPopupVisible(!validSelection(committedRegion, committedTown));
    window.dispatchEvent(new CustomEvent('campo-noble:regions-ready', { detail: { region: committedRegion, comuna: committedTown } }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('campo-noble:set-region', (event) => {
    commitSelection(
      (event.detail?.region || '').trim().toUpperCase(),
      event.detail?.comuna || '',
      event.detail?.source || 'external'
    );
  });
  window.addEventListener('campo-noble:reset-region-draft', () => {
    resetDraftSelection('external-reset');
  });
  window.addEventListener('storage', (event) => {
    if (event.key === REGION_KEY || event.key === TOWN_KEY) initialize();
  });
})();
